// extracted by mini-css-extract-plugin
export default {"container":"footer_container__N5+G0"};